const HTTP_URL_RE = /^https?:\/\//i;

export const normalizeConfiguredUrl = (value?: string | null): string =>
  (value || "").trim().replace(/\/+$/, "");

export const getApiRootFromBase = (value?: string | null): string => {
  const apiBase = normalizeConfiguredUrl(value);
  return apiBase.endsWith("/api") ? apiBase.slice(0, -4) : apiBase;
};

export const getConfiguredApiBaseUrl = (fallback = ""): string =>
  normalizeConfiguredUrl(
    (import.meta.env.VITE_API_URL as string | undefined) || fallback
  );

export const getConfiguredApiRootUrl = (fallback = ""): string =>
  getApiRootFromBase(
    (import.meta.env.VITE_API_URL as string | undefined) || fallback
  );

export const getApiOriginFromBase = (
  value?: string | null,
  fallbackOrigin = ""
): string => {
  const apiBase = normalizeConfiguredUrl(value);
  if (!apiBase) return "";

  try {
    return new URL(apiBase, fallbackOrigin || undefined).origin;
  } catch {
    return getApiRootFromBase(apiBase);
  }
};

export const joinUrlPath = (base: string, path: string): string => {
  const normalizedBase = normalizeConfiguredUrl(base);
  const normalizedPath = String(path || "")
    .trim()
    .replace(/^\/+/, "");
  if (!normalizedBase) return `/${normalizedPath}`;
  return `${normalizedBase}/${normalizedPath}`;
};

export const resolveConfiguredApiUrl = (
  url: string,
  fallback = "",
  options: { devApiOrigin?: string } = {}
): string => {
  if (!url) return url;
  const trimmedUrl = url.trim();
  if (HTTP_URL_RE.test(trimmedUrl)) return trimmedUrl;

  const apiRoot = getConfiguredApiRootUrl(fallback);
  if (!apiRoot && import.meta.env.DEV && options.devApiOrigin) {
    return `${normalizeConfiguredUrl(options.devApiOrigin)}${
      trimmedUrl.startsWith("/") ? "" : "/"
    }${trimmedUrl}`;
  }
  if (apiRoot) {
    return `${apiRoot}${trimmedUrl.startsWith("/") ? "" : "/"}${trimmedUrl}`;
  }
  return trimmedUrl;
};
